import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { pdf } from "@react-pdf/renderer";
import { PackingSlipPdf } from "../../../packingSlip/modules/features/PackingSlipPdf";
import { RouteModel } from "../../domain/models/routeModel";

interface TruckLayoutExportButtonProps {
  route: RouteModel;
}

export const PackingSlipExportButton = ({
  route,
}: TruckLayoutExportButtonProps) => {
  const { t } = useTranslation("common");

  const handleClick = async function () {
    const blob = await pdf(
      <PackingSlipPdf packingSlips={route.packingSlips} />,
    ).toBlob();

    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  return (
    <Button
      variant={"primary"}
      className="btn-sm"
      onClick={handleClick} // eslint-disable-line @typescript-eslint/no-misused-promises
    >
      {t("Download packing slips")}
    </Button>
  );
};
